import React, { Component } from 'react';
import { Layout, Card, Tag } from 'antd';
import styles from './index.module.less';
import menuData from './faq-menu-data';
import mockListData from './mock-faq-data'
import DocList from '@/components/DocList'
import Doc from '@/components/Doc'
import NoticeLayout from '@/components/Notice'
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import { RouteRegExp } from '@souche-f2e/muji-router';

const mapStateToProps = (rootState) => {
  return { 
    currentRoute: rootState.router,
    faq: rootState.faq
  };
};

@connect(mapStateToProps)
class FAQComponent extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      currentRoute,
    } = this.props; 

    const onListClick = (item) => {
      dispatch.router.push(`/support/FAQ?docId=${item.id}`);
    }
    const onMenuClick = (docType) => {
      dispatch.router.push(`/support/FAQ?docType=${docType}`);
    }
    const setMenuItemKeyPath = (itemPath) => {
      dispatch.faq.updatePath({
        itemPath
      });
    }
    const location = this.props.faq;

    const getSelectedData = () => {
      const levelList = typeof location.docType === 'string' ? location.docType.split(',') : [];
      let dataSelect = (location.docType === '' || location.docType === '0') ? mockListData : mockListData.filter(elem => elem.type === location.docType);
      return dataSelect;
    }
    const listItem = (
      <DocList
        dataSource={getSelectedData()}
        className={styles.doclist}
        listType='FAQ'
        onClick={onListClick}
      ></DocList>
    );
    const docItem = (
      <Doc
        dataSource={mockListData.filter(elem => elem.id == location.docId)}
        className={styles.doclist}
        docType={'FAQ'}   
      ></Doc>
    );
    const renderItem = () => { return location.docId === '' ? listItem : docItem };
    return (
      <NoticeLayout
        menuData={menuData}
        currentRoute={currentRoute}
        setMenuItemKeyPath={setMenuItemKeyPath}
        setDocType={onMenuClick}
        itemPath={location.itemPath}
        listType='FAQ'
        sideType='FAQ'
        titleName='FAQ'>
        <div className={styles.content}>
        {renderItem()}
        </div>
      </NoticeLayout>
    )
  }
}


export default FAQComponent;